/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetChatResult } from '../../models/get-chat-result';

export interface GetChatsByChatid$Params {
  ChatId: number;
}

export function getChatsByChatid(
  http: HttpClient,
  rootUrl: string,
  params: GetChatsByChatid$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetChatResult>> {
  const rb = new RequestBuilder(rootUrl, getChatsByChatid.PATH, 'get');
  if (params) {
    rb.path('ChatId', params.ChatId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetChatResult>;
    }),
  );
}

getChatsByChatid.PATH = '/Chats/chats/{ChatId}';
